import { useFormContext } from "react-hook-form";
import InputField from "@medoma/components/InputField/InputField";
import {
  informationFieldConfigValueSchema,
  type IInformationFieldConfigValue,
} from "@/api/Patients";
import { useLingui } from "@lingui/react/macro";

export type PlannedAdmissionDateTimeInputFields = {
  plannedAdmissionDateTime: string;
};

const PlannedAdmissionDateTimeInput = ({
  plannedAdmissionDateTimeFieldConfig,
}: {
  plannedAdmissionDateTimeFieldConfig: IInformationFieldConfigValue;
}) => {
  const { t } = useLingui();
  const {
    register,
    formState: { errors },
  } = useFormContext<PlannedAdmissionDateTimeInputFields>();

  return (
    <InputField
      type="date"
      {...register("plannedAdmissionDateTime", {
        required: {
          value:
            plannedAdmissionDateTimeFieldConfig ===
            informationFieldConfigValueSchema.enum.required,
          message: t`Ange planerad inskrivning`,
        },
      })}
      label={t`Planerad inskrivning`}
      showOptionalLabel={
        plannedAdmissionDateTimeFieldConfig ===
        informationFieldConfigValueSchema.enum.optional
      }
      errorMessage={errors.plannedAdmissionDateTime?.message}
    />
  );
};

export default PlannedAdmissionDateTimeInput;
